import { AxiosError } from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../components/Notification';
import HttpStatus from '../../../../../enums/httpStatus';
import { formAPI as mainCompAPI } from '../../../../../services/requests';
import { Form } from '../../../../../types';

type Props = {
  closeModal: () => void;
  reqCallback: () => void;
  selectedItem: Form;
};

const ModalDeleteJSX = ({ closeModal, reqCallback, selectedItem }: Props) => {
  const { t } = useTranslation();

  const [waitingResponse, setWaitingResponse] = useState(false);

  const reqDelete = async () => {
    setWaitingResponse(true);

    const source = mainCompAPI.axios.CancelToken.source();

    try {
      mainCompAPI.query = '';
      const res = await mainCompAPI.delete(selectedItem.id as number);

      if (res.status === HttpStatus.OK) {
        setWaitingResponse(false);
        frontendNotification({
          message: t('successfullyDeleted'),
          type: 'success',
        });

        reqCallback();
        closeModal();
      } else {
        throw res;
      }
    } catch (err) {
      if (!mainCompAPI.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    }

    setWaitingResponse(false);
    return () => {
      source.cancel('Component got unmounted');
    };
  };

  return (
    <Modal
      title={`${t('delete')} ${t('flow')}`}
      showModal
      closeModal={closeModal}
      cancelButton={closeModal}
      action={() => reqDelete()}
      actionNameBtn={t('delete')}
      isLoading={waitingResponse}
    >
      <p>
        {`${t('deleteSure')}?`}
        <p>
          <b>{t('id')}:</b> {selectedItem.id}
        </p>
        <p>
          <b>{t('description')}:</b> {selectedItem.description}
        </p>
      </p>
    </Modal>
  );
};

export default ModalDeleteJSX;
